const CONFIG = {
  API_URL: process.env.VUE_APP_API || 'https://laravel.ehabnassar.com/api',
};

export default CONFIG;
